<template>
  <main class="min-h-screen w-full overflow-x-hidden overflow-y-auto">
    <slot />
  </main>
</template>
